<!-- 纵向排列商品列表 -->
<template>
  <div class="limited-special-container limited-special-box" :style="{marginBottom: (data.marginBottom ) / 16 + 'rem'}">
    <h2>{{data.title}}<span>{{data.subTitle}}</span></h2>
    <div class="list">
      <div class="list-item" v-for="(item,index) in list" :key="index">
        <div class="item">
          <img :src="item.icon" alt="" loading="lazy">
          <div class="middle">
            <p class="item-title">{{item.firstClass}}<span class="tip"
                v-if="item.labelCopywriting">{{item.labelCopywriting}}</span></p>
            <p class="current-price"><span class="icon">¥</span>{{item.price}}<span class="text">起</span></p>
          </div>
          <span class="btn" @click="handleClick(item,index)">去开通</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import clientUtil from '../common/clientUtil';
  import { post } from '../common/http';
  import { goodsListSort, sensorsBuriedPoint } from '../common/util';
  export default {
    props: {
      data: {
        type: Object,
        default: () => { return {} }
      }
    },
    data() {
      return {
        list: [
          {
            icon: 'https://www.haohuan.com/datahub/file/2021-01/09cbd7191017ec0d03ab54eac91b3e39.png',
            firstClass: '爱奇艺月卡',
            price: '29.9',
            labelCopywriting: '限时活动',
          },
        ],
        vipEntrance: this.$route.query.from,
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      loadData() {
        if (this.data.idList.indexOf("0") != -1) {
          return;
        }
        const data = {
          productCode: this.data.idList
        };
        post('/api/saveMoneyCard/right/cheapest', data).then(res => {
          this.list = goodsListSort(data.productCode, res.data)
        })
      },
      handleClick(item, index) {
        const sensorObj = {
          LocationPage: `${this.$route.query.code}${document.title}`,
          EntryName: this.data.title,
          EntryRank: index + 1,
          RightName: item.productCode
        };
        sensorsBuriedPoint('MarketingPageClick', sensorObj)
        clientUtil.openNewWebPage({
          pageUrl: `flutter://economicalCard/rightsDetail?callback_origin=${this.vipEntrance}&firstClass=${item.firstClass}&equityType=1&product_code=${item.productCode}`,
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .limited-special-box {
    h2 {
      padding-top: 16px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 8px;
      padding-left: 12px;

      span {
        margin-left: 8px;
        font-size: 13px;
        line-height: 19px;
      }
    }

    .current-price {
      margin-bottom: 2px;
      font-size: 17px;
      font-family: DINPro-Medium, DINPro;
      color: #ff3838;
      line-height: 23px;

      .icon {
        margin-right: 2px;
        font-size: 13px;
        font-weight: bold;
        color: #ff3838;
        font-family: DINAlternate-Bold, DINAlternate;
        line-height: 18px;
      }

      .text {
        margin-left: 1px;
        font-size: 11px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #ff3838;
        line-height: 18px;
      }
    }
  }

  .limited-special-container {
    background-color: #fff;
    border-radius: 8px;
    width: 351px;
    padding-bottom: 4px;

    h2 {
      color: #2e2e33;

      span {
        color: #919199;
      }
    }
    .list {
      width: 351px;

      &-item {
        padding: 0 16px;
        height: 79px;

        &:last-child {
          .item {
            &:after {
              border-bottom-color: transparent !important;
            }
          }
        }

        .item {
          display: flex;
          height: 100%;
        }

        .item-title {
          margin-bottom: 5px;
          padding-top: 19px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #2e2e33;
          line-height: 19px;

          .tip {
            padding: 0 4px;
            display: inline-block;
            margin-left: 8px;
            background: #ff3838;
            border-radius: 2px;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #ffffff;
            line-height: 13px;
            position: relative;
            top: -2px;
            padding: 1px 4px;
            font-size: 10px;
          }
        }

        img {
          margin-top: 20px;
          margin-right: 8px;
          width: 40px;
          height: 40px;
        }

        .middle {
          flex: 1;
        }

        .btn {
          width: 60px;
          height: 27px;
          border: 0.5px solid #ff3838;
          border-radius: 16px;
          margin-top: 27px;
          font-size: 13px;
          font-weight: 500;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 27px;
          color: #ff3838;
          text-align: center;

          &:before {
            width: 120px;
            height: 54px;
            border-radius: 32px;
            border: 1px solid #ff3838 !important;
            top: -8px;
            left: -11px;
          }
        }
      }
    }
  }
</style>
